// 后端的值类型枚举
export enum RAW_VALUE_TYPE {
  // 文本-固定值
  FIXED = 'fixed',

  // 图片标签-固定值
  IMAGE_FIXED = 'image_fixed',

  // 动态值
  DYNAMICS = 'dynamics',

  // 图片标签-动态值
  IMAGE_DYNAMICS = 'image_dynamics',

  // 多个值
  MULTIPLE = 'multiple',

  // 随机码
  SKU = 'sku',

  // 随机码
  SPU = 'spu',

  FIX_SN = 'fix_sn',

  SPU_FIX = 'spu_fix',

  /** 规格属性（自定 SKU 货号），value 为 {"sepcName":"","specValueName":""} */
  FIX_SPEC = 'fix_spec',
}

export enum TEMPLATE_TYPE {
  TIKTOK = 'tiktok',
  TIKTOK_FULL = 'tiktok_full',
  TIKTOK_LOCAL = 'tiktok_local',
  SHOP_LINE = 'shopline',
  TEMU = 'temu',
  TEMU_LOCAL = 'temu_local',
  SHEIN = 'shein',
  AMAZON = 'amazon',
}

/** 新增店铺所属平台展示文案（含适用于说明） */
export const SHOP_PLATFORM_DISPLAY_MAP: Record<
  string,
  {
    label: string;
    desc?: string;
  }
> = {
  [TEMPLATE_TYPE.TEMU]: {
    label: 'Temu',
    desc: '适用于：全托、半托',
  },
  [TEMPLATE_TYPE.TIKTOK]: {
    label: 'Tiktok跨境',
    desc: '适用于：跨境（美/欧/日/墨/东南亚）',
  },
  [TEMPLATE_TYPE.TIKTOK_LOCAL]: {
    label: 'TikTok本土',
    desc: '适用于：本土（美/日/东南亚/巴西）',
  },
  [TEMPLATE_TYPE.TIKTOK_FULL]: {
    label: 'TikTok全托',
    desc: '适用于：全托管、品牌托管、本地托管',
  },
  [TEMPLATE_TYPE.SHEIN]: {
    label: 'Shein',
    desc: '适用于：全托、半托、自运营',
  },
};

/** TikTok 跨境店铺区域说明（纯前端展示，提交不传值） */
export const TIKTOK_STORE_REGION_TEXT =
  '支持美国、欧洲（英国、德国、意大利、西班牙、法国）、日本、墨西哥、东南亚（菲律宾、马来西亚、越南、泰国、新加坡）';

/** TikTok 本土店铺区域（提交 region 字段） */
export enum TIKTOK_LOCAL_REGION {
  US = 'US',
  AS = 'AS',
  EU = 'EU',
  GLOBAL = 'GLOBAL',
}

export const TIKTOK_LOCAL_REGION_OPTIONS = [
  {
    label: '美国',
    value: TIKTOK_LOCAL_REGION.US,
  },
  {
    label: '日本、东南亚（菲律宾、马来西亚、越南、泰国、新加坡、印度尼西亚）',
    value: TIKTOK_LOCAL_REGION.AS,
  },
  {
    label: '巴西',
    value: TIKTOK_LOCAL_REGION.EU,
  },
];

/** Temu 本土店铺区域 */
export enum TEMU_LOCAL_REGION {
  US = 'US',
}

export const TEMU_LOCAL_REGION_OPTIONS = [{ label: '美国', value: TEMU_LOCAL_REGION.US }];

/** TikTok 全托店铺业务类型 */
export enum TIKTOK_SELLER_TYPE {
  FULL = 'full',
  BRAND = 'brand',
  LOCAL = 'local',
}

export const TIKTOK_SELLER_TYPE_OPTIONS = [
  { label: '全托管', value: TIKTOK_SELLER_TYPE.FULL },
  { label: '品牌托管', value: TIKTOK_SELLER_TYPE.BRAND },
  { label: '本地托管', value: TIKTOK_SELLER_TYPE.LOCAL },
];

// 值类型枚举
export enum VALUE_TYPE {
  // 固定值
  FIXED = RAW_VALUE_TYPE.FIXED,

  // 动态值
  DYNAMICS = RAW_VALUE_TYPE.DYNAMICS,

  // 多个值
  MULTIPLE = RAW_VALUE_TYPE.MULTIPLE,
}

export const RAW_MAP = {
  [RAW_VALUE_TYPE.FIXED]: VALUE_TYPE.FIXED,
  [RAW_VALUE_TYPE.DYNAMICS]: VALUE_TYPE.DYNAMICS,
  [RAW_VALUE_TYPE.IMAGE_FIXED]: VALUE_TYPE.FIXED,
  [RAW_VALUE_TYPE.IMAGE_DYNAMICS]: VALUE_TYPE.DYNAMICS,
};

// 值类型下拉选项
export const VALUE_TYPE_OPTIONS = [
  {
    label: '固定值',
    value: VALUE_TYPE.FIXED,
  },
  {
    label: '动态值',
    value: VALUE_TYPE.DYNAMICS,
  },
];

// 包含多个值的类型下拉选项
export const VALUE_TYPE_OPTIONS_MUL = [
  {
    label: '固定值',
    value: VALUE_TYPE.FIXED,
  },
  {
    label: '动态值',
    value: VALUE_TYPE.DYNAMICS,
  },
  {
    label: '多个值',
    value: VALUE_TYPE.MULTIPLE,
  },
];

// 富文本类型枚举
export enum RICHTEXT_TYPE {
  // 文本
  TEXT = 'text',

  // 图片标签
  IMAGE_TAG = 'image_tag',
}

// 富文本类型选项
export const RICHTEXT_TYPE_OPTIONS = [
  {
    label: '文本',
    value: RICHTEXT_TYPE.TEXT,
  },
  {
    label: '图片',
    value: RICHTEXT_TYPE.IMAGE_TAG,
  },
];

// 动态值类型枚举
export enum DYNAMICS_VALUE_TYPE {
  // 结果图 / 现展示名：轮播图 (images-${number})
  IMAGES = 'images',

  // 商品来源图 / 原轮播图 (goodsImages_image-${number})
  GOODS_IMAGES_IMAGE = 'goodsImages_image',

  // 商品去水印图(goodsImages_watermark-${number})
  GOODS_IMAGES_WATERMARK = 'goodsImages_watermark',

  // 商品换背景图(goodsImages_change_background-${number})
  GOODS_IMAGES_CHANGE_BACKGROUND = 'goodsImages_change_background',

  // 商品全能改图(goodsImages_part_replace-${number})
  GOODS_IMAGES_PART_REPLACE = 'goodsImages_part_replace',

  // 商品裁剪压缩图(goodsImages_compress-${number})
  GOODS_IMAGES_COMPRESS = 'goodsImages_compress',

  // 采集图片(goodsImages_crawling-${number})
  GOODS_IMAGES_CRAWLING = 'goodsImages_crawling',

  // 原图
  ORIGINAL = 'original',

  // 印花图（单张）
  PRINTING = 'printing',

  // 印花图多张(prints-${number}，n>1)
  PRINTS = 'prints',

  // 标题(titles-${string})
  TITLES = 'titles',

  // // 原标题
  // TITLE = 'title',

  // // 中文标题
  // CN_TITLE = 'cnTitle',

  // // 英文标题
  // EN_TITLE = 'enTitle',

  // 名称
  NAME = 'name',
}

// 需要选择“第几张”的动态图片类型
export const DYNAMICS_INDEXED_IMAGE_VALUE_TYPES: string[] = [
  DYNAMICS_VALUE_TYPE.IMAGES,
  DYNAMICS_VALUE_TYPE.GOODS_IMAGES_IMAGE,
  DYNAMICS_VALUE_TYPE.GOODS_IMAGES_WATERMARK,
  DYNAMICS_VALUE_TYPE.GOODS_IMAGES_CHANGE_BACKGROUND,
  DYNAMICS_VALUE_TYPE.GOODS_IMAGES_PART_REPLACE,
  DYNAMICS_VALUE_TYPE.GOODS_IMAGES_COMPRESS,
  DYNAMICS_VALUE_TYPE.GOODS_IMAGES_CRAWLING,
];

export function getDefaultValueByValueType(valueType: RAW_VALUE_TYPE) {
  if ([RAW_VALUE_TYPE.DYNAMICS, RAW_VALUE_TYPE.IMAGE_DYNAMICS].includes(valueType)) {
    return 'images-1';
  }
  return '';
}

/** 是否为印花图动态值（printing 或 prints-n） */
export function isPrintingDynamicsValue(value?: string | null) {
  if (!value) return false;
  const type = String(value).split('-')[0];
  return type === DYNAMICS_VALUE_TYPE.PRINTING || type === DYNAMICS_VALUE_TYPE.PRINTS;
}

/** 印花图张数：printing → 1；prints-n → n */
export function getPrintingIndex(value?: string | null) {
  if (!value || value === DYNAMICS_VALUE_TYPE.PRINTING) return 1;
  const [type, index] = String(value).split('-');
  if (type === DYNAMICS_VALUE_TYPE.PRINTS || type === DYNAMICS_VALUE_TYPE.PRINTING) {
    const n = Number(index);
    return Number.isFinite(n) && n > 0 ? n : 1;
  }
  return 1;
}

/** 编码印花图动态值：1 → printing；>1 → prints-n */
export function encodePrintingValue(index: number | string) {
  const n = Math.max(1, Number(index) || 1);
  return n <= 1 ? DYNAMICS_VALUE_TYPE.PRINTING : `${DYNAMICS_VALUE_TYPE.PRINTS}-${n}`;
}

export function getTitleByValue(value: string) {
  if (isPrintingDynamicsValue(value)) {
    const n = getPrintingIndex(value);
    return n <= 1 ? '印花图' : `印花图-${n}`;
  }
  const titles = value.split('-');
  if (titles.length === 2) {
    const t = findDynamicsOption(DYNAMICS_VALUE_TYPE_OPTIONS, titles[0])?.label;
    return t ? t + '-' + titles[1] : value;
  }
  return findDynamicsOption(DYNAMICS_VALUE_TYPE_OPTIONS, value)?.label || value;
}

/** 从规格列表提取「规格属性」下拉选项（按 parentSpecName 去重） */
export function getSpecAttrOptions(
  specs?: Array<{ parentSpecName?: string } | null | undefined> | null
): { label: string; value: string }[] {
  if (!specs?.length) return [];
  const seen = new Set<string>();
  const options: { label: string; value: string }[] = [];
  for (const item of specs) {
    const name = item?.parentSpecName?.trim();
    if (!name || seen.has(name)) continue;
    seen.add(name);
    options.push({ label: name, value: name });
  }
  return options;
}

/** 后端约定字段名为 sepcName（非 specName） */
export type FixSpecPayload = {
  sepcName: string;
  specValueName: string;
};

export function parseFixSpecValue(raw?: string | null): FixSpecPayload {
  if (!raw) return { sepcName: '', specValueName: '' };
  try {
    const parsed = JSON.parse(raw);
    if (parsed && typeof parsed === 'object') {
      return {
        sepcName: String(parsed.sepcName ?? ''),
        specValueName: String(parsed.specValueName ?? ''),
      };
    }
  } catch {
    // 兼容旧数据：纯字符串视为已选规格名
    return { sepcName: String(raw), specValueName: '' };
  }
  return { sepcName: String(raw), specValueName: '' };
}

export function encodeFixSpecValue(sepcName: string, specValueName = ''): string {
  return JSON.stringify({ sepcName, specValueName });
}

export function getFixSpecSepcName(raw?: string | null): string {
  return parseFixSpecValue(raw).sepcName;
}

/** 从 SKU 行规格列提取 { 规格名: 规格值 }（只读列或 key 以 spec- 开头） */
export function getSkuRowSpecValueMap(
  skuFields?: Array<{
    key?: string;
    name?: string;
    readonly?: boolean;
    values?: Array<{ value?: unknown }>;
  }> | null
): Record<string, string> {
  const map: Record<string, string> = {};
  (skuFields || []).forEach((field) => {
    const isSpecField = !!field?.readonly || !!field?.key?.startsWith?.('spec-');
    if (!isSpecField) return;
    const name = field.name?.trim();
    const value = field.values?.[0]?.value;
    if (!name || value == null || `${value}` === '') return;
    map[name] = String(value);
  });
  return map;
}

/** 写入某行 skuRules 前，按该行规格值补全 fix_spec.specValueName */
export function resolveFixSpecSkuRules<T extends { type: string; value?: string }>(
  values: T[] | undefined,
  specValueMap?: Record<string, string> | null
): T[] | undefined {
  if (!values?.length) return values;
  return values.map((item) => {
    if (item.type !== RAW_VALUE_TYPE.FIX_SPEC) return item;
    const { sepcName } = parseFixSpecValue(item.value);
    const specValueName = sepcName ? String(specValueMap?.[sepcName] ?? '') : '';
    return {
      ...item,
      value: encodeFixSpecValue(sepcName, specValueName),
    };
  });
}

export function findDynamicsOption(
  options: {
    label: string;
    value: string;
    description?: string;
    children?: { label: string; value: string; description?: string }[];
  }[] = [],
  value?: string
) {
  if (!value) return undefined;
  for (const option of options) {
    if (option.value === value) return option;
    const child = option.children?.find((item) => item.value === value);
    if (child) return child;
  }
  return undefined;
}

// 动态值类型下拉选项
export const DYNAMICS_VALUE_TYPE_OPTIONS = [
  {
    label: '轮播图',
    value: DYNAMICS_VALUE_TYPE.IMAGES,
    description: '原结果图，商品最终生成图片',
  },
  {
    label: '来源图',
    value: DYNAMICS_VALUE_TYPE.GOODS_IMAGES_IMAGE,
    description: '商品库的原始图片',
  },
  {
    label: '裁剪压缩图',
    value: DYNAMICS_VALUE_TYPE.GOODS_IMAGES_COMPRESS,
    description: '从商品库进行裁剪压缩的结果图',
  },
  {
    label: '去水印图',
    value: DYNAMICS_VALUE_TYPE.GOODS_IMAGES_WATERMARK,
    description: '从商品库进行去水印的结果图',
  },
  {
    label: '换背景图',
    value: DYNAMICS_VALUE_TYPE.GOODS_IMAGES_CHANGE_BACKGROUND,
    description: '从商品库进行换背景的结果图',
  },
  {
    label: '全能改图',
    value: DYNAMICS_VALUE_TYPE.GOODS_IMAGES_PART_REPLACE,
    description: '从商品库进行全能改图的结果图',
  },
  {
    label: '原图',
    value: DYNAMICS_VALUE_TYPE.ORIGINAL,
  },
  {
    label: '印花图',
    value: DYNAMICS_VALUE_TYPE.PRINTING,
  },
  {
    label: '采集图片',
    value: DYNAMICS_VALUE_TYPE.GOODS_IMAGES_CRAWLING,
  },
  {
    label: '标题',
    value: DYNAMICS_VALUE_TYPE.TITLES,
  },
  {
    label: '名称',
    value: DYNAMICS_VALUE_TYPE.NAME,
  },
];

// 动态值类型下拉选项，只包含文本相关
export const DYNAMICS_TEXT_VALUE_TYPE_OPTIONS = [
  {
    label: '标题',
    value: DYNAMICS_VALUE_TYPE.TITLES,
  },
  {
    label: '名称',
    value: DYNAMICS_VALUE_TYPE.NAME,
  },
];

// 动态值类型下拉选项，只包含图片相关（刊登模板）
export const DYNAMICS_IMAGE_VALUE_TYPE_OPTIONS = [
  {
    label: '轮播图',
    value: DYNAMICS_VALUE_TYPE.IMAGES,
    description: '原结果图，商品最终生成图片',
  },
  {
    label: '来源图',
    value: DYNAMICS_VALUE_TYPE.GOODS_IMAGES_IMAGE,
    description: '商品库的原始图片',
  },
  {
    label: '裁剪压缩图',
    value: DYNAMICS_VALUE_TYPE.GOODS_IMAGES_COMPRESS,
    description: '从商品库进行裁剪压缩的结果图',
  },
  {
    label: '去水印图',
    value: DYNAMICS_VALUE_TYPE.GOODS_IMAGES_WATERMARK,
    description: '从商品库进行去水印的结果图',
  },
  {
    label: '换背景图',
    value: DYNAMICS_VALUE_TYPE.GOODS_IMAGES_CHANGE_BACKGROUND,
    description: '从商品库进行换背景的结果图',
  },
  {
    label: '全能改图',
    value: DYNAMICS_VALUE_TYPE.GOODS_IMAGES_PART_REPLACE,
    description: '从商品库进行全能改图的结果图',
  },
  {
    label: '原图',
    value: DYNAMICS_VALUE_TYPE.ORIGINAL,
  },
  {
    label: '印花图',
    value: DYNAMICS_VALUE_TYPE.PRINTING,
  },
  {
    label: '采集图片',
    value: DYNAMICS_VALUE_TYPE.GOODS_IMAGES_CRAWLING,
  },
];

// 导出模板动态值类型下拉选项（商品库图组为二级菜单）
export const EXPORT_DYNAMICS_IMAGE_VALUE_TYPE_OPTIONS = [
  {
    label: '轮播图',
    value: DYNAMICS_VALUE_TYPE.IMAGES,
    description: '原结果图，商品最终生成图片',
  },
  {
    label: '商品库图组',
    value: 'goodsImagesGroup',
    description: '由商品库生成的图片组',
    children: [
      {
        label: '来源图',
        value: DYNAMICS_VALUE_TYPE.GOODS_IMAGES_IMAGE,
        description: '商品库的原始图片',
      },
      {
        label: '裁剪压缩图',
        value: DYNAMICS_VALUE_TYPE.GOODS_IMAGES_COMPRESS,
        description: '从商品库进行裁剪压缩的结果图',
      },
      {
        label: '去水印图',
        value: DYNAMICS_VALUE_TYPE.GOODS_IMAGES_WATERMARK,
        description: '从商品库进行去水印的结果图',
      },
      {
        label: '换背景图',
        value: DYNAMICS_VALUE_TYPE.GOODS_IMAGES_CHANGE_BACKGROUND,
        description: '从商品库进行换背景的结果图',
      },
      {
        label: '全能改图',
        value: DYNAMICS_VALUE_TYPE.GOODS_IMAGES_PART_REPLACE,
        description: '从商品库进行全能改图的结果图',
      },
    ],
  },
  {
    label: '原图',
    value: DYNAMICS_VALUE_TYPE.ORIGINAL,
  },
  {
    label: '印花图',
    value: DYNAMICS_VALUE_TYPE.PRINTING,
  },
  {
    label: '采集图片',
    value: DYNAMICS_VALUE_TYPE.GOODS_IMAGES_CRAWLING,
  },
];

export function getRawValueTypeByValueTypeAndRichTextType(options: {
  valueType: VALUE_TYPE;
  richTextType?: RICHTEXT_TYPE;
}) {
  const { valueType, richTextType } = options;
  if (valueType === VALUE_TYPE.MULTIPLE) {
    return VALUE_TYPE.MULTIPLE;
  }
  if (richTextType === RICHTEXT_TYPE.IMAGE_TAG) {
    if (valueType === VALUE_TYPE.FIXED) {
      return RAW_VALUE_TYPE.IMAGE_FIXED;
    }
    return RAW_VALUE_TYPE.IMAGE_DYNAMICS;
  }

  if (valueType === VALUE_TYPE.FIXED) {
    return RAW_VALUE_TYPE.FIXED;
  }

  return RAW_VALUE_TYPE.DYNAMICS;
}

export function getValueTypeByRawValueType(type: RAW_VALUE_TYPE) {
  if (type === RAW_VALUE_TYPE.MULTIPLE) {
    return RAW_VALUE_TYPE.MULTIPLE;
  }
  if ([RAW_VALUE_TYPE.FIXED, RAW_VALUE_TYPE.IMAGE_FIXED].includes(type)) {
    return VALUE_TYPE.FIXED;
  }

  return VALUE_TYPE.DYNAMICS;
}

export function getRichtextTypeByRawValueType(type: RAW_VALUE_TYPE) {
  if ([RAW_VALUE_TYPE.IMAGE_FIXED, RAW_VALUE_TYPE.IMAGE_DYNAMICS].includes(type)) {
    return RICHTEXT_TYPE.IMAGE_TAG;
  }

  return RICHTEXT_TYPE.TEXT;
}
